import {
  META_SET_COUNTRIES,
  SET_META_TRACKER_PLATFORMS,
  SET_META_AD_PLATFORMS,
} from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
  countries: [],
  tracking_platforms: null,
  ad_platforms: null,
};

const Meta = (state = initialState, action) => {
  switch (action.type) {
    case META_SET_COUNTRIES:
      return {
        ...state,
        countries: action.payload,
      };
    case SET_META_AD_PLATFORMS:
      return {
        ...state,
        ad_platforms: action.payload,
      };
    case SET_META_TRACKER_PLATFORMS:
      return {
        ...state,
        tracking_platforms: action.payload,
      };
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default Meta;
